
import { IClientAttributeModel } from '../../../../../../../Types/ClientModelTypes';
import { IUrvalCondition, IValue } from '../../../../../../../Types/UrvalTypes';
import ConditionValue from '../../ConditionValue/ConditionValue';
import { update } from 'ramda';
import { set } from '../../../Utils/UrvalConditionObjectUtils';
import { Theme } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';

interface IProps {
  attribute: IClientAttributeModel;
  condition: IUrvalCondition;
  setCondition: (newCondition: IUrvalCondition[]) => void;
  disabled: boolean;
  renderControls: (index: number, showAddButton?: boolean) => React.ReactNode;
  classes?: any;
}

const styles = (theme: Theme) =>
  ({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    indentPadding: {
      paddingLeft: 20,
      borderLeft: '1px solid rgba(0,0,0,0.54)',
    },
  } as const);

const ValueConditionValuesUnstyled: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const setValue = (idx: number, newValue: string | number | null) => {
    const newValueObj = set(
      'value',
      newValue != null ? newValue : undefined,
      props.condition.values[idx]
    );
    const newValues: IValue[] = update(
      idx,
      newValueObj,
      props.condition.values
    );
    props.setCondition([set('values', newValues, props.condition)]);
  };

  const setToValue = (idx: number, newValue: string | number | null) => {
    const newValueObj = set(
      'toValue',
      newValue != null ? newValue : undefined,
      props.condition.values[idx]
    );
    const newValues: IValue[] = update(
      idx,
      newValueObj,
      props.condition.values
    );
    props.setCondition([set('values', newValues, props.condition)]);
  };

  const { condition, attribute, disabled, renderControls } = props;

  return (
    <>
      {condition.values.map((value, index) => (
        <div
          key={value.id}
          className={classNames(props.classes.container, {
            [props.classes.indentPadding]: index !== 0,
          })}
        >
          <>
            <ConditionValue
              idx={index}
              value={value}
              operator={condition.op}
              setValue={setValue}
              setToValue={setToValue}
              attribute={attribute}
              disabled={disabled}
            />
            {renderControls(index, index === 0)}
          </>
        </div>
      ))}
    </>
  );
};

export const ValueConditionValues = withStyles(
  ValueConditionValuesUnstyled,
  styles
);
